import { Redirect, Route, Switch } from 'react-router-dom';

import { rootPaths } from 'routes/paths';
import { MyGiftCardsListPage } from 'features/my-gift-cards/pages/MyGiftCardsListPage';
import { myGiftCardsPaths } from 'features/my-gift-cards/routes/paths';
import { GiftCardEditorPage } from 'features/my-gift-cards/pages/GiftCardEditorPage';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

export const MyGiftCardsRouter = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('myRewards')} />
      <Switch>
        <Route path={myGiftCardsPaths.static.root} exact component={MyGiftCardsListPage} />
        <Route path={myGiftCardsPaths.static.card} exact component={GiftCardEditorPage} />

        <Route>
          <Redirect to={rootPaths.static.notFound} />
        </Route>
      </Switch>
    </>
  );
};
